import React from 'react';

import FlexibleProductShowView from '@components/shared/flexible_products/FlexibleProductShowView';
import adminFlexibleProductService from '@services/admin/flexibleProductService';
import { useLoaderData } from 'react-router-dom';

export default function AdminFlexibleProductShow() {
  const flexibleProduct = useLoaderData();

  return (
    <FlexibleProductShowView
      flexibleProduct={flexibleProduct}
      service={adminFlexibleProductService}
      role="admin"
    />
  );
}
